import { createContext } from "react";
import { TPlatform } from "@ecp-pageTypes";

export const DeviceTypeMobileContext = createContext<TPlatform>("DESKTOP");
